export default "/server-build/img/e60232323f44760f0e111386be10a374.png";